module.exports = __webpack_public_path__ + "img/reference15.9feec5b9.jpg";